package uz.ferro.erp.feature.appuser.model

import kotlinx.serialization.Serializable

@Serializable
data class Role (
    var id: Long? = null,
    var name: String = ""
)